/*------------------------------------------------------------------------------------------------------------------
about：全局的、不需要引入的函数，在此处注册
author：马兆铿
date：2017-11-16
* -----------------------------------------------------------------------------------------------------------------*/
exports.install = function(Vue, options) {
  /*  提示操作成功
  * */
  Vue.prototype.toast_success = function(msg) {
    this.$vux.toast.show({
      text: msg || "操作成功",
      type: "success",
      time: 1000
    });
  };

  /*  提示操作失败
  * */
  Vue.prototype.toast_fail = function(msg) {
    this.$vux.toast.show({
      text: msg || "操作失败",
      type: "cancel"
    });
  };
};



// WEBPACK FOOTER //
// ./src/utils/base.js